import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ filter, onRefresh }) => {
  const getEmptyStateContent = () => {
    switch (filter) {
      case 'assigned':
        return {
          icon: 'ClipboardList',
          title: 'Keine zugewiesenen Aufträge',
          description: 'Aktuell sind Ihnen keine neuen Aufträge zugewiesen.',
          actionText: 'Aktualisieren'
        };
      case 'in_progress':
        return {
          icon: 'Clock',
          title: 'Keine laufenden Arbeiten',
          description: 'Sie haben derzeit keine Aufträge in Bearbeitung.',
          actionText: 'Aktualisieren'
        };
      case 'done':
        return {
          icon: 'CheckCircle',
          title: 'Keine abgeschlossenen Aufträge',
          description: 'Sie haben heute noch keine Aufträge abgeschlossen.',
          actionText: 'Aktualisieren'
        };
      default:
        return {
          icon: 'Search',
          title: 'Keine Aufträge gefunden',
          description: 'Es wurden keine Aufträge für Sie gefunden.',
          actionText: 'Aktualisieren'
        };
    }
  };

  const content = getEmptyStateContent();

  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-4">
        <Icon name={content?.icon} size={32} className="text-text-secondary" />
      </div>
      <h3 className="text-lg font-semibold text-text-primary mb-2">
        {content?.title}
      </h3>
      <p className="text-text-secondary mb-6 max-w-sm">
        {content?.description}
      </p>
      <Button
        variant="outline"
        onClick={onRefresh}
        iconName="RefreshCw"
        iconPosition="left"
      >
        {content?.actionText}
      </Button>
    </div>
  );
};

export default EmptyState;